import {
  UPDATE_ONBOARDING_FORM,
  INITIALIZE_ONBOARDING,
  USER_LOGOUT
} from '../actions/types'

const initialState = {
  athlete_profile_id: '',
  currentForm: 'sign-up',
  prevForm: '',
  coupon: null,
}

export default function onboarding(state = initialState, action){
  const { form } = action
  let newState

  switch (action.type) {
    case UPDATE_ONBOARDING_FORM:
      newState = {
        ...state,
        ...form
      }
      return newState
    case INITIALIZE_ONBOARDING:
      return initialState
    case USER_LOGOUT:
      return initialState
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/onboarding.js